import authAxios, { authHeader } from "../data";

const fetchAll = async (contractNumber: string) => {
  const response = await authAxios.get(
    `/api/Accesses/${contractNumber}/Documents`,
    {
      headers: authHeader(),
    },
  );

  return response.data;
};

const download = async (contractNumber: string, id: string) => {
  const response = await authAxios.get(
    `/api/Accesses/${contractNumber}/Documents/${id}/download`,
    {
      headers: authHeader(),
      responseType: "blob",
    },
  );

  return response.data;
};

const PortalDocuments = {
  fetchAll,
  download,
};

export default PortalDocuments;
